import type { PimFieldValue } from "@thenounproject/lingo-core";
import { createAction } from "@redux/actions/actionCreators";

/**
 * Commits a variant field value. If the committed envelope matches the product's
 * envelope for the same identifier, the reducer collapses it to `source: "inherited"`.
 */
const [useCommitVariantFieldValue, commitVariantFieldValue] = createAction<{
  productUuid: string;
  variantKey: string;
  identifier: string;
  value: PimFieldValue;
}>("product/commitVariantFieldValue");

export default useCommitVariantFieldValue;
export { commitVariantFieldValue };
